import { Pricing } from '@/components/shared/Pricing';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Team } from '@/hooks/useTeams';

interface PaywallDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  newTeam?: Team;
}

export const PaywallDialog = ({
  open,
  onOpenChange,
  newTeam,
}: PaywallDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl">
        <Pricing newTeam={newTeam} />
      </DialogContent>
    </Dialog>
  );
};
